import Axios from "@/plugins/axios";

class AuthApi {
  login(user) {
    return Axios.post("authentication_token", {
      email: user.email.trim(),
      password: user.password.trim(),
    });
  }

  register(candidacy) {
    return Axios.post("api/public/signup", {
      address: candidacy.address.trim(),
      birth_department: candidacy.birth_department.trim(),
      birthday: candidacy.birthday.trim(),
      birthplace: candidacy.birthplace.trim(),
      birthCityId: candidacy.birth_city_id ? candidacy.birth_city_id : "",
      city: candidacy.city.trim(),
      civility: candidacy.civility.trim(),
      firstname: candidacy.firstname.trim(),
      marriedname: candidacy.marriedname ? candidacy.marriedname.trim() : "",
      lastname: candidacy.lastname.trim(),
      nationality: candidacy.nationality,
      password: candidacy.password.trim(),
      password2: candidacy.password2.trim(),
      phone_number: candidacy.phone_number.trim(),
      signupToken: candidacy.signupToken,
    });
  }

  requestSignUpEmailToken(email) {
    return Axios.post("api/public/signup/request-email-token", {
      email: email.trim(),
    });
  }

  verifySignUpEmailToken(token) {
    return Axios.post("api/public/signup/verify-email-token", {
      token: token,
    });
  }

  requestNewPassword(email) {
    return Axios.post("api/public/password/forget", {
      email: email.trim(),
    });
  }

  sendNewPassword(token, password) {
    return Axios.post("api/public/candidate/account/password/reset", {
      token: token,
      password: password.trim(),
    });
  }

  verifyEmail(token) {
    return Axios.post("api/public/verify-email", {
      token: token,
    });
  }

  resendVerificationEmail(email) {
    return Axios.post("api/public/resend-verification-email", {
      email: email.trim(),
    });
  }
}

export default new AuthApi();
